import { render, staticRenderFns } from "./DispatchRequestHistory.vue?vue&type=template&id=292ce1f0&scoped=true&"
import script from "./DispatchRequestHistory.vue?vue&type=script&lang=js&"
export * from "./DispatchRequestHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292ce1f0",
  null
  
)

export default component.exports